export var isMobile = function () {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
export { CountryUtils } from './countryUtils';
export { CredentialUtils } from './credentialUtils';
export * from './dateUtils';
export * from './infoProviderUtils';
export { ObjectUtils } from './objectUtils';
export * from './filtersUtils';
export * from './queryStringUtils';
